module.exports = __webpack_public_path__ + "6bf2e6145d3c3c056c6a46ffa4398613.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/img_ELDAR_EXPANDED_W_1200px_H_660px.jpg
// module id = 393
// module chunks = 0